import styled from '@emotion/styled';
import { css } from '@emotion/react';

const callToActionSizes = ({ size }) => {
  const sizes = {
    l: css`
      font-size: 1.125rem;
      line-height: 1.625rem;
    `,
    m: css`
      font-size: 0.875rem;
      line-height: 1.125rem;
    `,
    s: css`
      font-size: 0.75rem;
      line-height: 1rem;
    `,
  };

  return sizes[size];
};

const CallToAction = styled.span`
  label: CallToAction;

  font-weight: 800;
  transition: color 0.2s ease;
  cursor: pointer;

  ${callToActionSizes}
`;

export default CallToAction;
